var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiColorCoinmarketcap = function SvgMultiColorCoinmarketcap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 2,
    y: 2,
    fill: "#2B6AFF",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.435 13.17a.65.65 0 0 1-.654.044c-.242-.135-.372-.45-.372-.88v-1.316c0-.632-.254-1.081-.679-1.203-.718-.207-1.254.66-1.461.985l-1.27 2.026v-2.472c-.015-.57-.203-.912-.559-1.014-.235-.068-.588-.04-.931.476l-2.84 4.491A4.9 4.9 0 0 1 7.098 12a4.91 4.91 0 0 1 4.9-4.908 4.915 4.915 0 0 1 4.909 4.908v.028c.027.524-.146.94-.47 1.143zM18.003 12v-.025C17.981 8.675 15.296 6 11.998 6S6 8.691 6 12c0 3.307 2.691 6 5.998 6a5.98 5.98 0 0 0 4.078-1.6.547.547 0 0 0-.734-.809 4.9 4.9 0 0 1-1.647 1.012 4.92 4.92 0 0 1-3.799-.175 4.8 4.8 0 0 1-1.544-1.158l2.557-4.048v1.868c0 .898.352 1.188.649 1.273.296.085.75.026 1.225-.734l1.41-2.25a4 4 0 0 1 .125-.19v1.146c0 .838.342 1.509.94 1.84a1.75 1.75 0 0 0 1.759-.07c.658-.422 1.018-1.185.98-2.104z"
  })));
};
export { SvgMultiColorCoinmarketcap as ReactComponent };